/**
 * @file: Login.
 * @authors: zhangkang.
 * @createDate: 2020/10/26.
 * @Description: 附件管理
 */
import request from '@/utils/request'

/**
 * 登录
 * @author: dawangf(dawangf@sina.com)
 * @createDate: 2020/10/26
 * @param data {Object} 参数
 */
export function login(data) {
  return request({
    type: 'auth',
    url: '/oauth/token',
    method: 'post',
    data
  })
}

/**
 * 获取用户
 * @author: dawangf(dawangf@sina.com)
 * @createDate: 2020/10/26
 * @param data {Object} 参数
 */
export function isLogin(data) {
  return request({
    type: 'auth',
    url: '/oauth/isLogin',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js